var ReasonCodeModel = require('./model'),
    Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV');


/** Now this is like an abstract class */


module.exports = Backbone.Collection.extend({

    model: ReasonCodeModel,

    /* Return the codes of models containing text in code or description, case-insensitive */
    /* ( Currently just used on the sytem collection */
    getCodesofModelsWithText: function(text) {
        return this.chain()
            .filter( function(c) {
                return c.codeOrDescriptionContainsText(text);
            })
            .map( function(c) {
                return c.get('code');
            })
            .value();
    },

    // Only called from Shape, but generic enough to leave here
    // Could put this from the model now
    getNonResponsiveCodeModel: function() {

        var nonResponseReasonCodeCode = fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE;

        return this.findWhere({
            code: nonResponseReasonCodeCode
        });
    },

    containsNonResponsiveReasonCode: function() {
        return this.getNonResponsiveCodeModel() !== undefined;
    },

    getInactiveCodes: function() {
        return this.where({ active:false });
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/reasonCodes/collection.js
 ** module id = 80
 ** module chunks = 0
 **/